import { readable } from "svelte/store";

const canvas = document.createElement("canvas");
canvas.width = 1;
canvas.height = 1;
const ctx = canvas.getContext("2d", { willReadFrequently: true });

function startsAndEndsWith(text: string, substring: string) {
    return text.startsWith(substring) && text.endsWith(substring);
}

function colorToRGBA(color: string): Uint8ClampedArray {
    if (startsAndEndsWith(color, '"') || startsAndEndsWith(color, '"')) {
        color = color.substring(1, color.length - 1);
    }
    // Returns the color as an array of [r, g, b, a] -- all range from 0 - 255
    // color must be a valid canvas fillStyle. This will cover most anything
    // you'd want to use.
    // Examples:
    // colorToRGBA('red')  # [255, 0, 0, 255]
    // colorToRGBA('#f00') # [255, 0, 0, 255]
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, 1, 1);
    return ctx.getImageData(0, 0, 1, 1).data;
}

function byteToHex(num: number): string {
    // Turns a number (0-255) into a 2-character hex number (00-ff)
    return ('0'+num.toString(16)).slice(-2);
}

export function colorToHex(color: string) {
    // Convert any CSS color to a hex representation
    // Examples:
    // colorToHex('red')            # '#ff0000'
    // colorToHex('rgb(255, 0, 0)') # '#ff0000'
    if (color === "transparent") return "transparent";

    let rgba = colorToRGBA(color);
    let hex = [0,1,2].map(idx => byteToHex(rgba[idx])).join('');
    return "#"+hex;
} 

export const devicePixelRatio = readable(window.devicePixelRatio, (set) => {
    let remove = () => {};

    function update() {
        set(window.devicePixelRatio);
        remove();
        let media = matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
        media.addEventListener("change", update);
        remove = () => {
            media.removeEventListener("change", update);
            remove = () => {};
        }
    }
    update();

    return () => {
        remove();
    }
});

